<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Lịch sử import mautic</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <!-- <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="[
                {
                  id: 'SUCCESS',
                  text: 'Thành công'
                },
                {
                  id: 'FAIL',
                  text: 'Thất bại'
                },
                {
                  id: 'PROCESSING',
                  text: 'Đang xử lý'
                }
              ]"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div> -->
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng:
            <strong class="text-primary">{{ pagination?.total?.toLocaleString('vi-VN') }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
              class="mt-1"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(statusImport)="{ item }">
                <span
                  :class="{
                    'badge badge-success': item.statusImport === 'SUCCESS',
                    'badge badge-success': item.statusImport === 'DONE',
                    'badge badge-danger': item.statusImport === 'FAIL',
                    'badge badge-warning': item.statusImport === 'PROCESSING',
                  }"
                >
                  {{ getStatusText(item.statusImport) }}
                </span>
              </template>
              <template #cell(action)="{ item }">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    v-if="item.filePath"
                    @click="downloadErrorFile(item.filePath)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Tải file thành công
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="item.fileErrorPath"
                    @click="downloadErrorFile(item.fileErrorPath)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Tải file lỗi
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import { MauticService } from '@/services/mautic.service'

  export default {
    name: 'gpdkkd-sale',
    data() {
      return {
        Config,
        filterTable: [
          { key: 'index', label: 'STT', class: 'text-center' },
          { key: 'fileName', label: 'Tên file' },
          { key: 'totalRows', label: 'Tổng số dòng', class: 'text-center' },
          { key: 'successRows', label: 'Số dòng thành công', class: 'text-center' },
          {
            key: 'createdDate',
            label: 'Thời gian tạo',
            formatter: value =>
              value ? this.$options.filters.formatDate(value, 'HH:mm DD/MM/YYYY') : '-',
          },
          { key: 'statusImport', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
        ],
        lists: [],
        loading: false,
        tbLoading: false,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
      }
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
    },
    methods: {
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const response = await MauticService.getHistorys()
          if (response.code === 1000) {
            this.lists = response.data.content || []
            this.pagination.total = response.data.totalElements
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      getStatusText(status) {
        const statusMap = {
          SUCCESS: 'Thành công',
          DONE: 'Thành công',
          FAIL: 'Thất bại',
          PROCESSING: 'Đang xử lý',
        }
        return statusMap[status] || status
      },
      downloadErrorFile(fileErrorPath) {
        if (fileErrorPath) {
          window.open(fileErrorPath, '_blank')
        }
      },
    },
  }
</script>
